let self = {};

export default {
  props: {
    data: Object,
    visible: Boolean,
  },

  data() {
    return {
      form: {
        tel: "",
        name: "",
        addr: "",
        areaId: "",
        areaAxis: "",
      },
      area: {
        lazy: true,
        checkStrictly: true,
        expandTrigger: "hover",
        lazyLoad(node, resolve) {
          const { value = 0 } = node;
          self.$store
            .dispatch("app/getAreas", {
              parentId: value,
            })
            .then((data) => {
              const nodes = [];
              data.forEach(function (item) {
                if (item.end) {
                  const map = {
                    value: String(item.id),
                    label: String(item.name),
                    leaf: item.end,
                  };
                  nodes.push(map);
                } else {
                  const map = {
                    value: String(item.id),
                    label: String(item.name),
                    leaf: item.end,
                  };
                  nodes.push(map);
                }
              });
              // 通过调用resolve将子节点数据返回，通知组件数据加载完成
              resolve(nodes);
            });
        },
      },
      rules: {
        tel: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
          { min: 11, max: 11, message: "请输入正确的联系方式", trigger: "blur" },
        ],
        name: [{ required: true, message: "请输入收货人", trigger: "blur" }],
        addr: [{ required: true, message: "请输入详细收货地址", trigger: "blur" }],
        areaId: [{ required: true, message: "请选择收货地址", trigger: "blur" }],
      },
      areaValue: [],
    };
  },

  computed: {
    tel: {
      get() {
        return this.form.tel;
      },
      set(newValue) {
        if (newValue === "" || /^(1*)$/.test(newValue) || /^(1[0-9]*)$/.test(newValue)) {
          this.form.tel = newValue;
        }
      },
    },
  },

  mounted() {
    self = this;
    const { tel = "", name = "", addr = "", areaId = "", areaAxis = "" } = this.data || {};
    this.form = {
      tel,
      name,
      addr,
      areaId,
      areaAxis,
    };
    this.areaValue = areaAxis.replace("$", "").split("$");
  },

  methods: {
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.areaValue = "";
          this.$emit("confirm", this.form, this.$refs.form);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    areaChange(value = []) {
      const areaId = value[value.length - 1];
      this.form = {
        ...this.form,
        areaId,
        areaAxis: `$${value.join("$")}`,
      };
    },
  },
};
